// 留资下载页：《区块链团队安全自查清单》
// 页面只展示 6 个板块和示例问题，完整 25 项在 PDF 里（填表后下载）
export const CHECKLIST = {
  slug: 'checklist',
  zh: {
    nav: '安全自查清单',
    metaTitle: '区块链团队安全自查清单（免费下载）｜25 个问题看清钱从哪里丢 - 牧色安全',
    metaDesc: '免费下载《区块链团队安全自查清单》：资金与签名、员工电脑与账号、服务器与云、代码与供应链、防钓鱼、监控与应急，25 个问题 10 分钟自查。专为没有安全团队的区块链公司设计。',
    eyebrow: '免费下载',
    title: '区块链团队安全自查清单',
    titleHi: '25 个问题，10 分钟',
    sub: '近几年加密行业被盗的钱，大部分不是从合约漏洞丢的，而是从私钥、签名流程、员工电脑、钓鱼和第三方供应商这些链下环节丢的。这份清单不讲配置细节，只帮你看清方向：哪些地方已经做好，哪些地方该优先补。',
    points: ['专为没有专职安全团队的区块链公司设计', '每项都是"是/否"问题，创始人和技术负责人一起 10 分钟能过完', '最后有评分，告诉你风险在哪一档'],
    previewTitle: '清单覆盖的 6 个板块',
    previewSub: '每个板块列一个示例问题，完整 25 项在 PDF 里。',
    sections: [
      { n: '01', h: '资金与签名', count: 5, ex: '大额资金在多签或 MPC 钱包里，没有任何一个人能单独把钱转走吗？' },
      { n: '02', h: '员工电脑与账号', count: 5, ex: '员工离职当天，所有账号和权限能全部收回吗？' },
      { n: '03', h: '服务器与云', count: 4, ex: 'API Key 和私钥是不是还写在代码或配置文件里？' },
      { n: '04', h: '代码与供应链', count: 3, ex: '第三方依赖、外包代码和安全产品，有人审过再进生产吗？' },
      { n: '05', h: '防钓鱼与社工', count: 3, ex: '员工认得出假猎头、假会议链接和"跑一下测试代码"吗？' },
      { n: '06', h: '监控与应急', count: 5, ex: '出事时谁拍板、谁止损、找谁冻结，写下来了吗？' },
    ],
    form: {
      title: '填写信息，免费下载 PDF',
      company: '公司 / 团队名称',
      jobTitle: '职位',
      name: '姓名',
      contactType: '即时联系方式',
      types: { wechat: '微信', telegram: 'Telegram', phone: '电话' },
      placeholders: { wechat: '微信号', telegram: '@username', phone: '+86 138 0000 0000' },
      email: '邮箱（选填）',
      submit: '下载自查清单',
      sending: '正在生成下载链接…',
      privacy: '信息只用于发送清单和后续安全建议，不会提供给任何第三方。',
      errRequired: '请把信息填写完整',
      errContact: { wechat: '微信号格式不对', telegram: 'Telegram 用户名格式不对（4–32 位字母、数字或下划线）', phone: '电话号码格式不对' },
      errEmail: '邮箱格式不对',
      errRate: '提交太频繁了，请稍后再试，或直接发邮件到 ',
      errSend: '提交失败，请稍后再试，或直接发邮件到 ',
    },
    done: {
      badge: '已发送',
      title: '下载已开始',
      text: '如果没有自动下载，点下面的按钮。链接 24 小时内有效。',
      again: '重新下载',
      nextTitle: '自查完有没打勾的项？',
      nextText: '告诉我们你最担心的是哪几条，我们给你一个优先级建议。文字沟通就行，不用开会。',
      nextCta: '告诉我们你的情况',
    },
  },
  en: {
    nav: 'Security Self-Check',
    metaTitle: 'Blockchain Team Security Self-Check (Free PDF) | 25 Questions - Musesec',
    metaDesc: 'Free download: a 25-question security self-check for blockchain teams without a dedicated security team. Covers funds and signing, laptops and accounts, servers and cloud, supply chain, phishing, and incident response.',
    eyebrow: 'Free download',
    title: 'Blockchain Team Security Self-Check',
    titleHi: '25 questions, 10 minutes',
    sub: 'By dollar value, most crypto funds stolen in recent years were not lost to smart-contract bugs. They were lost off-chain: private keys, signing flows, employee laptops, phishing and third-party vendors. This checklist skips configuration details and shows you where you stand and what to fix first.',
    points: ['Built for blockchain companies without a dedicated security team', 'Every item is a yes/no question: founder and tech lead can finish it in 10 minutes', 'A simple score at the end tells you your risk level'],
    previewTitle: 'What the checklist covers',
    previewSub: 'One sample question per area. The full 25 items are in the PDF.',
    sections: [
      { n: '01', h: 'Funds & Signing', count: 5, ex: 'Can any single person move treasury funds alone?' },
      { n: '02', h: 'Devices & Accounts', count: 5, ex: 'Can you revoke all access on an employee\'s last day?' },
      { n: '03', h: 'Servers & Cloud', count: 4, ex: 'Are API keys or private keys still sitting in code or config files?' },
      { n: '04', h: 'Code & Supply Chain', count: 3, ex: 'Are dependencies, outsourced code and security tools reviewed before production?' },
      { n: '05', h: 'Phishing & Social Engineering', count: 3, ex: 'Would your staff spot a fake recruiter or a "just run this test code" request?' },
      { n: '06', h: 'Monitoring & Response', count: 5, ex: 'Is it written down who decides, who stops the bleeding and who to call for freezes?' },
    ],
    form: {
      title: 'Get the free PDF',
      company: 'Company / team',
      jobTitle: 'Job title',
      name: 'Name',
      contactType: 'Instant contact',
      types: { telegram: 'Telegram', wechat: 'WeChat', phone: 'Phone / WhatsApp' },
      placeholders: { telegram: '@username', wechat: 'WeChat ID', phone: '+1 555 000 0000' },
      email: 'Email (optional)',
      submit: 'Download the checklist',
      sending: 'Preparing your download…',
      privacy: 'We only use this to send the checklist and follow-up security tips. Never shared with third parties.',
      errRequired: 'Please fill in all fields',
      errContact: { telegram: 'Please enter a valid Telegram username (4–32 letters, digits or _)', wechat: 'Please enter a valid WeChat ID', phone: 'Please enter a valid phone number' },
      errEmail: 'Please enter a valid email',
      errRate: 'Too many requests. Please try again later or email ',
      errSend: 'Something went wrong. Please try again later or email ',
    },
    done: {
      badge: 'Sent',
      title: 'Your download has started',
      text: 'If it didn\'t start automatically, use the button below. The link is valid for 24 hours.',
      again: 'Download again',
      nextTitle: 'Some items left unticked?',
      nextText: 'Tell us which ones worry you most and we\'ll send back a prioritised recommendation. Text is fine, no call needed.',
      nextCta: 'Tell us your situation',
    },
  },
}
